import { useState } from 'react';
import { DeleteModal } from '@/components/DeleteModal';
import { enqueueSnackbar } from 'notistack';
import { ExerciseDTO, DeckDTO } from '../../generated';
import { ExerciseCardGridElement } from './list-elements/ExerciseCard';
import { ExerciseCardListElement } from './list-elements/ExerciseCardListElement';
import { useDeleteExercise } from '@/hooks/exercise-mutation.hooks';
import { useRemoveExerciseInDeck } from '@/hooks/deck-mutation.hooks';

export enum DisplayMode {
  Card,
  List,
}

interface ExerciseProps {
  display: DisplayMode;
  exercise: ExerciseDTO;
  deck?: DeckDTO;
  timeout: number;
  onClick?: () => void;
  onExerciseDeleted?: () => void;
}

export const ExerciseComponent = (props: ExerciseProps) => {
  const { deck, exercise } = props;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const removeDeckExerciseMutation = useRemoveExerciseInDeck();
  const deleteExerciseMutation = useDeleteExercise();

  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        nameOfObjectToDelete="Exercise"
        handleDelete={async () => {
          if (deck) {
            await removeDeckExerciseMutation.mutateAsync({ deckId: deck.id, exerciseId: exercise.id });
            enqueueSnackbar(`Exercise ${props.exercise.name} removed from deck !`, { variant: 'success' });
          } else {
            await deleteExerciseMutation.mutateAsync(exercise.id);
            enqueueSnackbar(`Exercise ${props.exercise.name} deleted!`, { variant: 'success' });
          }
          setShowDeleteModal(false);
          if (props.onExerciseDeleted) props.onExerciseDeleted();
        }}
      />
      {props.display === DisplayMode.List && <ExerciseCardListElement {...props} setShowDeleteModal={setShowDeleteModal} />}
      {props.display === DisplayMode.Card && <ExerciseCardGridElement {...props} setShowDeleteModal={setShowDeleteModal} />}
    </>
  );
};
